export default __webpack_public_path__ + "static/media/summary_mobile.7442e48b.png";